var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.214 75.088a14.67 14.67 0 01-6.543-9.407 126.661 126.661 0 01-.055-51.487c.4-1.914 1.18-3.728 2.296-5.334a15.3 15.3 0 019.777-6.287 142.356 142.356 0 0153.555-.063l-.006.015a15.662 15.662 0 015.558 2.197 14.727 14.727 0 016.537 9.414 126.757 126.757 0 01.052 51.482 14.49 14.49 0 01-2.294 5.334 15.323 15.323 0 01-9.786 6.288 142.387 142.387 0 01-53.546.056 15.633 15.633 0 01-5.545-2.208z",
    fill: "#C2E9FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A1DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M63.846 38.906H52.872v17.957h10.974zM47.386 32.921H36.412v23.942h10.974zM30.925 20.95H19.951v35.913h10.974z"
  }))));
}
export default SvgDiagram;